/** Triggers a browser download of a Blob under `filename` via a temporary object URL. */
export function downloadBlob(blob: Blob, filename: string): void {
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

/** Parses the filename from a `Content-Disposition` header value, or returns null when absent/unparseable. */
export function getFilenameFromContentDisposition(contentDisposition: string | null | undefined): string | null {
  if (!contentDisposition) {
    return null;
  }
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);
  return matches && matches[1] ? matches[1].replace(/['"]/g, "") : null;
}
